import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from "utils/moment/momentLocale";
import { useTranslation } from "react-i18next";

// import locale from 'antd/es/date-picker/locale/fr_FR';

import { Form, TimePicker, Col } from 'antd';

function TimeField({
  data,
  index,
  todayLabel,
  nowLabel,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'time-input-column', className);
  const { t } = useTranslation();

  const format = 'HH:mm';
  const now = moment();

  return data && (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames}
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={data?.displayLabel ? data?.label : data?.label}
        name={data?.name}
        className={data?.name + '-wrapper'}
        initialValue={
          data?.value ? moment(data?.value, format) : moment(now, format)
        }
        rules={[
          {
            required: data?.required || false,
            message: t("inputs.selectRequiredField")
          },
        ]}
      >
        <TimePicker
          format={format}
        />
      </Form.Item>
    </Col>
  );
};

TimeField.defaultProps = {
  index: 1,
  todayLabel: "absences.today",
  nowLabel: "absences.now"
};

TimeField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(TimeField);